
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from '@/components/ui/use-toast';

interface StudentGuidanceTabProps {
  onSubmit: (text: string, type: 'highschool') => void;
}

const StudentGuidanceTab: React.FC<StudentGuidanceTabProps> = ({ onSubmit }) => {
  const [studentInterests, setStudentInterests] = useState('');

  const handleSubmit = () => {
    if (studentInterests.trim()) {
      onSubmit(studentInterests, 'highschool');
      setStudentInterests('');
    } else {
      toast({
        title: "Empty Interests",
        description: "Please describe your interests before submitting.",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="space-y-3 h-full flex flex-col pt-0">
      <h3 className="text-lg font-medium">Educational Guidance</h3>
      <p className="text-sm text-muted-foreground">
        Tell us about your interests, strengths, and aspirations to get personalized university and degree recommendations.
      </p>
      <Textarea 
        className="flex-1 min-h-[200px]"
        placeholder="Describe your interests, strengths, preferred subjects, and career aspirations..."
        value={studentInterests}
        onChange={(e) => setStudentInterests(e.target.value)}
      />
      <Button onClick={handleSubmit} className="ml-auto">
        Get Recommendations
      </Button>
    </div>
  );
};

export default StudentGuidanceTab;
